export const apiConstants = {
  Authenticate: 'TokenAuth/Authenticate',
  Logout: 'services/app/logout',
  GetCurrentLoginInformation: 'services/app/Session/GetCurrentLoginInformations',
};
